import { render, staticRenderFns } from "./PopupMenu.vue?vue&type=template&id=03fa3f26&scoped=true"
import script from "./PopupMenu.vue?vue&type=script&lang=ts"
export * from "./PopupMenu.vue?vue&type=script&lang=ts"
import style0 from "./PopupMenu.vue?vue&type=style&index=0&id=03fa3f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fa3f26",
  null
  
)

export default component.exports